export const industries = [
  "Technology & IT",
  "Healthcare & Pharmaceuticals",
  "Finance & Banking",
  "Education & Research",
  "Engineering & Manufacturing",
  "Media & Entertainment",
  "Retail & E-commerce",
  "Legal Services",
  "Consulting & Professional Services",
  "Energy & Utilities",
  "Government & Public Sector",
  "Telecommunications",
  "Transportation & Logistics",
  "Agriculture & Food Production",
  "Construction & Real Estate",
  "Hospitality & Tourism",
  "Non-Profit & NGO",
];
